import React from "react";
import { StatusChip } from "@pushpress/shared-components";
import { AppointmentStatus } from "../Appointments.types";
import {
  colorByAppointmentStatusName,
  getAppointmentStatusName,
} from "../AppointmentsUtils";

export interface AppointmentStatusChipProps {
  data: {
    eventStatus: AppointmentStatus;
    isLateCancel?: boolean | null;
    appointmentCredit?: object | null;
    unpaidReason?: string | null;
  };
}

function AppointmentStatusChip(props: AppointmentStatusChipProps) {
  const { data } = props;
  const statusName = getAppointmentStatusName(data);
  const statusColor = colorByAppointmentStatusName[statusName];
  return <StatusChip label={statusName} color={statusColor} size="small" />;
}

export default AppointmentStatusChip;
